"use client";

import { c as _c } from "react/compiler-runtime";
import { Button, Link } from "@opensea/next-ui-kit";
import { Anchor } from "@opensea/ui-kit/icons";
import { useTranslations } from "next-intl";
import { MoreMenuItem, MoreMenuItemAvatar, MoreMenuItemContent, MoreMenuItemTitle } from "./MoreMenuItem";
export function MoreMenuLeaderboardItem(t0) {
  const $ = _c(18);
  let isSheet;
  let onClick;
  let rest;
  if ($[0] !== t0) {
    ({
      isSheet,
      onClick,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = isSheet;
    $[2] = onClick;
    $[3] = rest;
  } else {
    isSheet = $[1];
    onClick = $[2];
    rest = $[3];
  }
  const t = useTranslations("MoreMenuLeaderboardItem");
  let t1;
  if ($[4] !== isSheet) {
    t1 = isSheet ? <Button icon={Anchor} size="lg" variant="secondary" /> : <MoreMenuItemAvatar icon={Anchor} />;
    $[4] = isSheet;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== t) {
    t2 = t("title");
    $[6] = t;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== t2) {
    t3 = <MoreMenuItemContent><MoreMenuItemTitle>{t2}</MoreMenuItemTitle></MoreMenuItemContent>;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] !== isSheet || $[11] !== rest || $[12] !== t1 || $[13] !== t3) {
    t4 = <MoreMenuItem isSheet={isSheet} {...rest}>{t1}{t3}</MoreMenuItem>;
    $[10] = isSheet;
    $[11] = rest;
    $[12] = t1;
    $[13] = t3;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== onClick || $[16] !== t4) {
    t5 = <Link href="/rewards" onClick={onClick} variant="unstyled">{t4}</Link>;
    $[15] = onClick;
    $[16] = t4;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  return t5;
}